<template>
  <div style="padding:8px 4px;">
    <div v-if="loading" style="padding:32px 0;text-align:center;opacity:0.4;font-size:14px;">불러오는 중…</div>
    <div v-else-if="!items.length" style="padding:32px 0;text-align:center;opacity:0.4;font-size:14px;">참조가 없습니다.</div>
    <table v-else class="w-full" style="font-size:13px;border-collapse:collapse;">
      <thead>
        <tr style="border-bottom:2px solid rgba(0,0,0,0.08);">
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:left;">참조 ID</th>
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:left;">유형</th>
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:right;">길이</th>
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:left;">상태</th>
          <th style="opacity:0.5;font-weight:600;padding:8px;text-align:right;">관리</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="r in items" :key="r.id" style="border-bottom:1px solid rgba(0,0,0,0.05);">
          <td style="padding:12px 8px;"><IdMono :value="r.id" :truncate="22"></IdMono></td>
          <td style="padding:12px 8px;opacity:0.5;">{{ r.contentType || '—' }}</td>
          <td style="padding:12px 8px;text-align:right;font-variant-numeric:tabular-nums;">{{ formatDuration(r.length) }}</td>
          <td style="padding:12px 8px;"><StatusPill :variant="statusVariant(r.status)"></StatusPill></td>
          <td style="padding:12px 8px;text-align:right;">
            <el-button v-if="r.status === 'active'" size="mini" type="text" @click="$emit('deactivate', r)">비활성화</el-button>
            <el-button v-else-if="r.status === 'inactive'" size="mini" type="text" @click="$emit('activate', r)">활성화</el-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import IdMono from '../components/IdMono.vue'
import StatusPill from '../components/StatusPill.vue'

const STATUS_MAP = {
  active: 'activated',
  inactive: 'deactivated',
  pending: 'pending',
  checking: 'pending',
}

export default {
  name: 'AssetReferencesTab',
  components: { IdMono, StatusPill },
  props: {
    assetId: { type: String, required: true },
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  methods: {
    statusVariant(s) { return STATUS_MAP[(s || '').toLowerCase()] || 'inactive' },
    formatDuration(seconds) {
      if (!seconds && seconds !== 0) return '—'
      const s = Math.floor(seconds)
      const m = Math.floor(s / 60)
      const r = s - m * 60
      return `${m}:${r.toString().padStart(2, '0')}`
    },
  },
}
</script>
